import Typography from "typography"
import Theme from "typography-theme-irving"
require('typeface-merriweather');
require('typeface-yrsa');

Theme.overrideThemeStyles = () => {
  return {
    "a.gatsby-resp-image-link": {
      boxShadow: `none`,
    },
    "a": {
      textDecoration: "none",
      color: "#00f"
    },
    "h3 a": {
      color: "unset"
    }
  }
};

Theme.headerFontFamily = ["Merriweather", "sans-serif"];
Theme.bodyFontFamily = ["Yrsa"];


const typography = new Typography(Theme);

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles()
}

export default typography
export const rhythm = typography.rhythm;
export const scale = typography.scale;
